module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/my_comment.229e7.png";